<mat-card [class]="type">
  <div class="d-flex">
    <div class="d-flex justify-content-center align-items-center">
      <mat-icon>{{ icon }}</mat-icon>
    </div>
    <div class="ml-3">
      <ng-content></ng-content>
    </div>
  </div>
</mat-card>
